import {AssignmentFilterModel, CustomerAddressModel, CustomerContactDetailsModel, CustomerFilterModel, CustomerModel, Input, SuperBit_swaggerClient, TreatmentFilterModel} from './superbit-api-models';
import generalSettings from '../json/general-settings.json';
import { isRealGuid } from '../utils/guidUtils';
import moment from 'moment';

export class SuesModel {
    client:any;
    constructor() {
        const apiUrl = localStorage.getItem('apiUrl');
        this.client = new SuperBit_swaggerClient(apiUrl ? apiUrl : generalSettings.apiUrl);
    }
    
    async suesFilter(request: any) {
        // The Sues page uses this both globally (no customerId) and inside a customer card.
        // For a not-yet-saved customer the id is a temp/empty value, not a persisted GUID;
        // skip the call so we don't send a non-uuid customerId to PostgreSQL. Only guard when
        // a customerId is actually present — the global search (customerId undefined) must pass.
        if (request && request.customerId && !isRealGuid(request.customerId)) {
            return null;
        }
        return this.client.suesFilter(request);
    }

    async sueUpdate(request: any) {
        return this.client.sueUpdate(request);
    }

    async sueFileUpload(request: any) {
        return this.client.sueDocumentsCreate(request);
    }

    async sueDocumentDelete(id: string) {
        return this.client.deleteSueDocument(id);
    }

    async suesGetById(request: any) {
        return this.client.suesGetById(request);
    }
    
    async sendSueComment(data: any) {
        return this.client.tasksUpsertAssignment(data);
    }

    async treatmentsUpsertTreatment(body: any) {
        return this.client.treatmentsUpsertTreatment(body);
    }

    async sueTypeGetAll() {
        return this.client.sueTypeGetAll();
    }

    async addSueType(body: any) {
        return this.client.suesAddSueType(body);
    }

    async deleteSueType(id: string) {
        return this.client.suesDeleteSueType(id);
    }

    async sueStatusGetAll() {
        return this.client.sueStatusGetAll();
    }

    async addSueStatus(body: any) {
        return this.client.suesAddSueStatus(body);
    }
    async deleteSueStatus(id: string) {
        return this.client.suesDeleteSueStatus(id);
    }

    async sueActivityStatusGetAll() {
        return this.client.sueActivityStatusGetAll();
    }

    async addSueActivityStatus(body: any) {
        return this.client.suesAddSueActivityStatus(body);
    }

    async deleteSueActivityType(id: string) {
        return this.client.suesDeleteSueActivityType(id);
    }

    async getVehiclePolicyTypes() {
        return this.client.policyGetPolicyTypes();
    }

    async addSuePayment(body: any) {
        return this.client.paymentUpsertPayment(body);
    }
    
    async addSueComment(body: any) {
        return this.client.suesAddSueComment(body);
    }


    // async signingDelete(id: string) {
    //     return this.client.signingDelete(id);
    // }
    
    // async getStatuses() {
    //     return this.client.getElementaryPolicyStatuses();
    // }

    // async addStatus(body: any) {
    //     return this.client.addElementaryPolicyStatus(body);
    // }

    // async deleteStatus(id: string) {
    //     return this.client.deleteElementaryPolicyStatus(id);
    // }

    formatDate(d: Date) {
        if (d) {
            return moment(d).format('YYYY-MM-DD');
        }
        return undefined; 
    }

    async exportSuesToExcel(filter: any){
        return this.client.suesExportToExcel(filter);
    }
    async fetchData () {
        let apiUrl = undefined;
        try {
            const response = await fetch('/config.json');
            const jsonData = await response.json();
            apiUrl = jsonData.apiUrl;
            localStorage.setItem('apiUrl', apiUrl)
            localStorage.setItem('appConfig', JSON.stringify(jsonData));
        } catch (error) {
            console.error('Error fetching data: ', error);
        }
        return apiUrl;
    };

    async PrintSue (id:string) {
        let url = await this.client.PrintSue(id);        
        return await this.fetchData()+url;
    };
}